import React from "react";
import { Button, Typography } from "@mui/material";
import { OpenInNew as OpenInNewIcon } from "../icons";
import { T } from "../routes/Translate";
import { brandColors } from "../theme";

const SITE_NAMES = {
  "mercadolibre.com.ar": "Mercado Libre",
  "eventbrite.com.ar": "Eventbrite",
};

export const getSiteName = (url) => {
  try {
    const host = new URL(url).hostname.replace(/^www\./, "");
    const known = Object.keys(SITE_NAMES).find((domain) => host === domain || host.endsWith(`.${domain}`));
    return known ? SITE_NAMES[known] : host;
  } catch {
    return "";
  }
};

// Para anuncios que no son de quien los publicó en Notiline (importados de
// otro sitio, con `sourceUrl`): en vez de Consultar/Reservar por chat, lleva a
// la publicación original, que es donde se puede contactar al anunciante real.
const ExternalListingButton = ({ url }) => {
  const site = getSiteName(url);
  return (
    <>
      <Button
        variant="contained"
        fullWidth
        size="large"
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        endIcon={<OpenInNewIcon />}
        sx={{
          textTransform: "none",
          fontWeight: 600,
          py: 1.5,
          bgcolor: brandColors.action,
          "&:hover": { bgcolor: brandColors.actionHover },
        }}
      >
        <T>Ver publicación en</T>&nbsp;{site}
      </Button>
      <Typography sx={{ fontSize: 12, color: "text.secondary", textAlign: "center", mt: 1 }}>
        <T>Este anuncio pertenece a otro sitio. Para consultar o reservar, hacelo en la publicación original.</T>
      </Typography>
    </>
  );
};

export default ExternalListingButton;
